var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 24.0001,
    r: 6.5,
    fill: "white",
    stroke: "#C6CCD9",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5135 10.4243L14.923 9.729C14.56 9.60223 14.2628 9.31275 14.0986 8.92188C13.9101 8.49642 13.9067 7.99236 14.0876 7.54491L14.7452 5.9178C15.3151 4.50764 15.2983 3.39144 14.6943 2.76041C14.1033 2.13508 13.0242 2.11007 11.6724 2.68384L1.99715 6.79055L1.67219 5.96243C1.51727 5.56763 1.074 5.37385 0.694398 5.53497C0.314794 5.6961 0.128472 6.15711 0.283394 6.55191L7.27377 24.3662C7.42869 24.761 7.87196 24.9548 8.25156 24.7937C8.63117 24.6325 8.81749 24.1715 8.66257 23.7767L6.81862 19.0776L16.4939 14.9709C17.8271 14.405 18.559 13.6001 18.566 12.7097C18.573 11.8193 17.8471 11.0153 16.5135 10.4243Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.bfae28646d29a2b3dfb9afb78f682045.svg";
export { ForwardRef as ReactComponent };